import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  validateBulkSequenceIsFilledCorrectly,
  validateStepsFieldsFilledCorrectly
} from 'UI/components/organisms/BulkEmailDrawer/utils';
import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';
import { getId } from 'UI/utils';

import { buildAttemptsFormKey } from '../BulkSequences.utils';

const attemptsFormFieldKey = BulkDrawerFormFieldsMap.Attempts.key;

export const useBulkDrawerAttemptsHandlers = ({ shouldAddSteps = false }) => {
  const { errors, getValues, setValue, unregister, watch } = useFormContext();
  const attemptsIds = watch(attemptsFormFieldKey, []);
  const { length: attemptsLength } = attemptsIds;

  const shouldDisableAddStepButton = useMemo(() => {
    const params = { errors, watch };

    if (shouldAddSteps) {
      return !validateStepsFieldsFilledCorrectly(params);
    }

    return !validateBulkSequenceIsFilledCorrectly(params);
  }, [errors, shouldAddSteps, watch]);

  const handleAddAttempt = useCallback(() => {
    const id = getId();
    const attempts = getValues()[attemptsFormFieldKey] || [];

    setValue(attemptsFormFieldKey, [...attempts, id]);
  }, [getValues, setValue]);

  const handleRemoveAttempt = useCallback(
    attemptId => () => {
      unregister(buildAttemptsFormKey(attemptId));

      if (attemptsLength === 1) {
        setValue(attemptsFormFieldKey, []);
        unregister(attemptsFormFieldKey);
      } else {
        const attempts = getValues()[attemptsFormFieldKey];
        const newAttempts = attempts.filter(id => id !== attemptId);

        setValue(attemptsFormFieldKey, newAttempts, true);
      }
    },
    [attemptsLength, getValues, setValue, unregister]
  );

  return {
    attemptsIds,
    attemptsLength,
    handleAddAttempt,
    handleRemoveAttempt,
    shouldDisableAddStepButton
  };
};
